module.exports = __webpack_public_path__ + "media/images/auth/register-bg-951d161274c555a719852a98970ac5c3.jpg";